<template>
  <v-dialog :value="value" width="750" @input="(v) => $emit('input', v)">
    <v-card
      class="pt-10 px-7 pb-7"
      color="secondary"
      :class="`${$vuetify.theme.dark ? 'dark' : ''}`"
    >
      <div class="d-flex align-center justify-space-between mb-10">
        <p class="text-h6 font-weight-medium">
          {{ $t("modalImage.cutImage") }}
        </p>
        <v-btn icon text v-ripple="false" @click="$emit('input', false)">
          <v-icon>$x</v-icon>
        </v-btn>
      </div>
      <vue-croppie
        class="mb-16"
        customClass="bcrop"
        ref="croppieRef"
        :enableOrientation="false"
        :enableResize="false"
        :boundary="{ width: 250, height: 250 }"
        :viewport="{ width: 250, height: 250, type: 'circle' }"
      >
      </vue-croppie>
      <div class="d-flex justify-center">
        <v-btn
          @click="crop()"
          :height="$vuetify.breakpoint.mobile ? 32 : 40"
          :width="$vuetify.breakpoint.mobile ? 130 : 160"
          class="font-weight-bold"
          :class="{
            'mr-3': $vuetify.breakpoint.mobile,
            'mr-6': !$vuetify.breakpoint.mobile,
          }"
          :loading="loading"
          color="success"
          >{{ $t("modalImage.save") }}</v-btn
        >
        <v-btn
          :height="$vuetify.breakpoint.mobile ? 32 : 40"
          :width="$vuetify.breakpoint.mobile ? 130 : 160"
          class="font-weight-bold"
          color="error"
          @click="$emit('input', false)"
          >{{ $t("modalImage.cancel") }}</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapActions, mapState, mapWritableState } from "pinia";
export default {
  props: {
    value: Boolean,
    image: String,
  },
  watch: {
    image(value) {
      if (value) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.croppieRef.bind({
              url: value,
            });
          });
        }, 275);
      }
    },
  },

  data() {
    return {
      cropped: null,
    };
  },
  computed: {
    ...mapState(useAuthStore, ["loading"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["uploadImg"]),
    // async createBlob(base64) {
    //   let res = await fetch(base64);
    //   let myBlob = await res.blob();

    //   return myBlob;
    // },
    async base64ToFile(base64) {
      const res = await fetch(base64);
      const buf = await res.arrayBuffer();
      const file = new File([buf], String(Date.now()) + ".jpg", {
        type: "image/jpg",
      });
      return file;
    },
    crop() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.

      let options = {
        format: "jpg",
        circle: false,
      };
      this.$refs.croppieRef.result(options, async (output) => {
        // this.cropped = output;
        const blob = await this.base64ToFile(output);
        const fim = await this.uploadImg(blob);
        if (fim);
        this.$emit("input", false);
      });
    },
  },
};
</script>
<style lang="scss">
.bcrop .cr-boundary {
  & .cr-viewport,
  & .cr-resizer {
    border: none;
    box-shadow: 0 0 2000px 2000px rgb(22 25 34 / 60%);
  }
}
.bcrop .cr-slider-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  &::before,
  &::after {
    content: "";
    display: inline-block;
    background-image: url("@/assets/icons/image-black.svg");
    background-size: contain;
    background-repeat: no-repeat;
  }
  &::before {
    width: 24px;
    height: 24px;
    margin-right: 15px;
  }
  &::after {
    width: 32px;
    height: 32px;
    margin-left: 15px;
  }
}
.dark .bcrop .cr-slider-wrap {
  &::before,
  &::after {
    background-image: url("@/assets/icons/image-white.svg");
  }
}
.bcrop .cr-slider-wrap input.cr-slider {
  width: 130px;
}
.bcrop .cr-slider-wrap input.cr-slider::-moz-range-progress {
  background: #161922;
}
.dark .bcrop .cr-slider-wrap input.cr-slider::-moz-range-progress {
  background: #f1f1f1;
}

.dark .bcrop .cr-slider-wrap input.cr-slider::-moz-range-track {
  background: #f1f1f1;
}
.bcrop .cr-slider-wrap input.cr-slider::-moz-range-track {
  background: #161922;
}

.dark .bcrop .cr-slider-wrap input.cr-slider::-webkit-slider-runnable-track {
  background: #f1f1f1;
}
.bcrop .cr-slider-wrap input.cr-slider::-webkit-slider-runnable-track {
  background: #161922;
}

.bcrop .cr-slider-wrap input.cr-slider::-webkit-slider-thumb {
  background: var(--v-secondary-base);
  border: 1px solid var(--v-primary-base);
}
.bcrop .cr-slider-wrap input.cr-slider::-moz-range-thumb {
  background: var(--v-secondary-base);
  border: 1px solid var(--v-primary-base);
}
</style>
